module.exports = __webpack_public_path__ + "static/img/61.a4d03f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/61.jpg
// module id = Od/v
// module chunks = 0